import React from 'react';
import { FormGroup, CheckboxInput } from 'arag-ui-lib';
import { Field, FormikErrors } from 'formik';
import PropTypes from 'prop-types';
import styles from './formikFieldWrapper.module.scss';

type Props = {
    inputProps: any;
    inline?: boolean;
    labelSize?: string | undefined;
    inputSize?: string | undefined;
    label: string;
    variant?: string;
    helpText?: string | null;
    validator?: any;
    getInputProps?: any;
    groupShape?: string;
    customErrorMessage?:
        | string
        | string[]
        | FormikErrors<any>
        | FormikErrors<any>[]
        | null
        | undefined;
    description?: string | null;
    infoText?: string | undefined;
    formGroupContainerStyle?: React.CSSProperties;
    hasInlineElements?: boolean;
    inlineGroupElements?: any;
};

const FormikFieldWrapper = (props: Props): JSX.Element => {
    const {
        inputProps,
        inline,
        labelSize,
        inputSize,
        label,
        variant,
        helpText,
        validator,
        getInputProps,
        groupShape,
        customErrorMessage,
        description,
        infoText,
        formGroupContainerStyle,
        hasInlineElements,
        inlineGroupElements,
    } = props;

    return (
        <Field name={inputProps.name} validate={validator}>
            {({
                field,
                form: {
                    touched,
                    errors,
                    setFieldValue,
                    setValues,
                    values,
                    setFieldError,
                    setFieldTouched,
                },
                meta,
            }: any) => {
                let finalInputProps = {} as any;
                if (getInputProps) {
                    finalInputProps = getInputProps({
                        field,
                        values,
                        setFieldValue,
                        setValues,
                        setFieldError,
                        errors,
                        meta,
                        setFieldTouched,
                    });
                } else if (inputProps) {
                    finalInputProps = inputProps;
                }
                return (
                    <div
                        id={
                            finalInputProps && finalInputProps.id
                                ? `${finalInputProps.id.replace('-', '_')}_form_group_wrapper`
                                : undefined
                        }
                        className={styles['container']}
                        style={formGroupContainerStyle}
                    >
                        {description && (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        )}
                        <FormGroup
                            id={
                                finalInputProps && finalInputProps.id
                                    ? finalInputProps.id.replace('-', '_')
                                    : null
                            }
                            inline={inline}
                            helpText={helpText}
                            errorMessage={
                                customErrorMessage
                                    ? customErrorMessage
                                    : meta.touched && meta.error
                                      ? meta.error
                                      : null
                            }
                            labelSize={labelSize}
                            inputSize={inputSize}
                            label={
                                <span
                                    dangerouslySetInnerHTML={{ __html: label }}
                                />
                            }
                            variant={variant}
                            groupShape={groupShape}
                            infoText={infoText}
                            maxCharacters={
                                finalInputProps.maxCharacters
                                    ? finalInputProps.maxCharacters
                                    : null
                            }
                            inputProps={{
                                ...field,
                                ...finalInputProps,
                            }}
                            hasInlineElements={hasInlineElements}
                            inlineGroupElements={inlineGroupElements}
                        />
                    </div>
                );
            }}
        </Field>
    );
};

export default FormikFieldWrapper;
